export function getAudioDuration(
  audioFile: File,
): Promise<{ duration: number }> {
  return new Promise((resolve, reject) => {
    const audiElement = document.createElement('audio')
    const url = URL.createObjectURL(audioFile)
    audiElement.setAttribute('src', url)
    audiElement.onloadeddata = () => {
      URL.revokeObjectURL(url)

      resolve({
        duration: audiElement.duration * 1000,
      })
    }
    audiElement.onerror = e => {
      reject(e)
    }
  })
}
